import {Component, Input, OnInit} from '@angular/core';
import {SmsModel} from '../../../model/smsModel';
import {CityDTO} from '../../../shared/dto/city.model';
import {smsSearchDTO} from '../../../shared/dto/smsSearchDTO';
import {SmsService} from '../../../shared/service/sms.service';
import {SmsMgtComponent} from '../sms-mgt.component';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {SmsPopupComponent} from '../sms-popup/sms-popup.component';
import {ActionMode} from '../../../shared/enums/action-mode.enum';

@Component({
  selector: 'app-sms-search-table',
  templateUrl: './sms-search-table.component.html',
  styleUrls: ['./sms-search-table.component.scss']
})
export class SmsSearchTableComponent implements OnInit {
  @Input() items:SmsModel[];
  @Input() index:number;
  @Input() page:number=1;
  @Input() itemsPerPage:number=5;
  private smsDTOS: SmsModel[] = [];

  constructor(private smsService:SmsService, private smsMgt:SmsMgtComponent,public modalService: NgbModal) { }

  ngOnInit() {
  this.loadAllRecords();
  }

  loadAllRecords() {
    this.smsService.getAllRecords().subscribe(
      (data: SmsModel[]) => {
        this.smsDTOS = data;

      });
  }

  onClickUpdate(item) {
    const modalRef = this.modalService.open(SmsPopupComponent,{
      windowClass :"xlModal"
    });
    modalRef.componentInstance.name = "Update SMS Details";
    modalRef.componentInstance.id = item.id;
    modalRef.componentInstance.phoneNo =  item.phoneNumber;
    modalRef.componentInstance.message =  item.message;
    modalRef.componentInstance.createdTime=item.createdTime;
    modalRef.componentInstance.status=item.status;
    modalRef.componentInstance.smsMgtCopy_ = item;
    modalRef.componentInstance.selectedMode = ActionMode.UPDATE;
    modalRef.result.then(
      (data: string) => {
        if (data == "Saved") {
            this.smsMgt.loadAllRecords();
        }
      },
      () => { }
    );


  }


}
